// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"f355511b","286":"f355511b","437":"93cc5207","527":"19132159","670":"a0b9b23d","810":"f355511b","907":"40707e3b"}[chunkId] + ".chunk.css";
};